export const NUM_MAX_RESERVATION_SLOTS = 10;
export const NUM_MIN_RESERVATION_SLOTS = 0;
export const NUM_MAX_NEW_RESERVATION_SLOTS = 10;
export const NUM_MIN_NEW_RESERVATION_SLOTS = 1;
export const TEXT_CHECK_IS_NEW_RESERVATION = '新規';

/**
 * 予約可能期間（当日基準・C3_CI_ZLABO-2912）
 * 未設定（null）の場合は BE と同じく UNLIMITED 扱いとする
 */
export const POSSIBLE_MONTH_CODE = {
  ONE_MONTH_AHEAD: '0',
  TWO_MONTHS_AHEAD: '1',
  UNLIMITED: '2',
};
